import { __cAuthService } from '@/services/client/__c.auth.service'
import { TForgotVerifyOtpParams } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useForgotVerifyOtpMutation = () => {
  return useMutation({
    mutationKey: ['forgot-verify-otp'],
    mutationFn: async (body: TForgotVerifyOtpParams) => {
      const response = await __cAuthService.forgotVerifyOtp(body)
      return response
    },
  })
}
